import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "o-grid" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--offset-0 o-grid__cell--9-480 o-grid__cell--offset-3-480 o-grid__cell--8-768 o-grid__cell--offset-3-768 o-grid__cell--7-1024 o-grid__cell--6-1200" }
const _hoisted_3 = {
  id: "tariffHeader",
  class: "one-col__tariff"
}
const _hoisted_4 = { class: "one-col__tariff-label" }
const _hoisted_5 = {
  key: 0,
  class: "one-col__tariff-name-price"
}
const _hoisted_6 = {
  key: 1,
  class: "one-col__tariff-name-price"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.piniaStore.state.isMakler ? "" : "Ihr ") + "Tarif", 1),
        _cache[2] || (_cache[2] = _createElementVNode("svg", {
          viewBox: "0 0 830 160",
          "aria-hidden": "true"
        }, [
          _createElementVNode("polygon", { points: "2,2 828,2 828,120 415,150 2,120" })
        ], -1)),
        (_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.props.produktbezeichnung), 1),
              _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.gesamtPreisFH)), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.props.produktbezeichnung), 1),
              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.gesamtPreisEinmalig)), 1)
            ]))
      ])
    ])
  ]))
}